import missionsActions from './missions.actions';
import groupMissionsActions from './group.missions.actions';

export default {
  ...missionsActions,
  ...groupMissionsActions
};
